
<ngx-loading [show]="isProcessing"></ngx-loading>

<div class="row h550">

  <div class="col-md-5 h500">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-header text-center">
        <h3 class="box-title ">Equipamentos para RD</h3><br />
        <span class="text-muted">Selecione para editar</span>
        <div class="divider"></div>
      </div>

      <div class="box-body h340">

        <div class="bx-tb-default-t1 pre-scrollable h300">
          <table class="table table-bordered table-hover">
            <thead class="thead-default">
              <tr>
                <th class="text-center">Nome</th>
              </tr>
            </thead>
            <tbody class="tbody-default">
              <tr *ngFor="let c of this.cadastrados" class="cp" (click)="getById(c.id)"
                [ngClass]="{'tr-info': this.form.get('id').value == c.id}">
                <td>{{ c.nome }}</td>
              </tr>
              <tr *ngFor="let v of this.voids">
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box-footer">
        <span class="pl-1">Total: <b>{{ this.cadastrados?.length }}</b> </span>
      </div>
    </div>
  </div>



  <div class="col-md-7 h500">
    <div class="box" [ngClass]="{'box-primary':  !this.isEditing, 'box-warning':  this.isEditing }">

      <div class="box-body" style="height: 490px;">

        <form novalidate style="padding-top: 80px;" [formGroup]="form"  id="form" (validSubmit)="submit()">


          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="form-group">
                <label for="nome">Nome</label>
                <input class="form-control" formControlName="nome" type="text" maxlength="50" required>
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('nome').hasError('isNotUniqueNome')">Este nome de equipamento RD já está em uso</small>
                </section>
              </div>
            </div>
          </div>
        </form>

      </div>


    </div>

  </div>
</div>

<div class="row mt-2">
  
  <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
    <div class="box-body">
      <div class="row">
        <div class="col-md-4">
          <div class="d-flex justify-content-start">
            <button type="button" class="btn btn-light pl-3 pr-3 mr-3" 
              [disabled]="!(this.isEditing && this.autorizacoes?.podeExcluir)"
              title="Exluir equipamento RD selecionado" (click)="showModalSm(modaldelete)">
              <span class="text-danger"><i class="fa fa-trash"></i></span><span class="pl-3">Excluir</span>
            </button>
          </div>
        </div>
        <div class="col-md-4">
          <div class="d-flex justify-content-center">
            <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
          </div>
        </div>
        <div class="col-md-4">

          <div class="d-flex justify-content-end">
            
            <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="reset()">Limpar</button>
            <button type="submit" class="btn pl-5 pr-5 mr-3 btn-shadow" form="form"
              [disabled]="(!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar))"
              [ngClass]="{'btn-primary': !this.isEditing, 'btn-warning': this.isEditing }">
              <span *ngIf="!this.isEditing">Cadastrar</span>
              <span *ngIf="this.isEditing">Editar</span>
            </button>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>

<ng-template #modaldelete let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">SIGEM CLOUD</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-3">
        <div class="d-flex justify-content-center">
          <img src="assets\images\icon-question.png" />
        </div>
      </div>
      <div class="col-md-9">
        <div class="alert alert-warning">
          <div class="d-flex justify-content-center">
            <span class="question-modal pt-3 pb-3">Deseja excluir o <b>Equipamento RD</b> selecionado?</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Não</button>
          <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2"
            (click)="delete(this.form.get('id').value, c)">Sim</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
